import React, { MouseEvent,useRef, useState } from 'react'

import cx from 'classnames'

import Portal from 'components/Portal'

interface PortalTooltipProps {
  children: React.ReactNode
  component?: React.ReactNode
  render?: () => React.ReactNode
  className?: string
  tooltipClassName?: string
}

const PortalTooltip: React.FC<PortalTooltipProps> = ({
  className,
  children,
  component,
  render,
  tooltipClassName
}) => {
  const content = useRef<HTMLDivElement | null>(null)
  const [position, setPosition] = useState<{
    top: number
    left: number
    height: number
  } | null>(null)

  const handleMouseEnter = (e: MouseEvent<HTMLSpanElement>) => {
    const rect = e.currentTarget.getBoundingClientRect()
    const height = content.current?.clientHeight || 0

    setPosition({
      top: rect.top - height - 10,
      left: rect.left + rect.width / 2,
      height
    })
  }

  return (
    <span
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setPosition(null)}
      className={cx('tide-tooltip--wrapper', className)}>
      {children}
      <Portal>
        <div
          onMouseEnter={() => setPosition(null)}
          className={cx('tide-tooltip', `tide-tooltip--up`, tooltipClassName, {
            'tide-tooltip--open': position !== null
          })}
          style={{ ...position, display: 'flex' }}
          ref={content}>
          {render ? render() : component}
        </div>
      </Portal>
    </span>
  )
}

export default PortalTooltip
